import {Component} from 'react'
import {parse as parseQueryString} from 'querystring'
import {withRouter} from 'react-router-dom'

export default function queryWatcher (CustomComponent) {
  const queryWatcher = class QueryWatcher extends Component {
    constructor(props) {
      super(props)
      this.state = {
        search: this.extractQueryString(props.location.search)
      }
    }

    extractQueryString(qsStr) {
      if (qsStr && qsStr.substr(0, 1) === '?') {
        return parseQueryString(qsStr.substr(1, qsStr.length))
      }
      return {}
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
      if (this.props.location === prevProps.location) {
        return
      }
      const queryString = this.extractQueryString(this.props.location.search)

      for (let key in queryString) {
        if (key === '' && queryString[key] === '') {
          delete queryString[key]
        }
      }

      this.setState({search: queryString})
    }

    render() {
      return (
        <CustomComponent {...this.props} queryString={this.state.search}/>
      )
    }
  }

  return withRouter(queryWatcher)
}
